import React from "react";

import "./Experience.css";

const Experience = () => {
  return (
    <div className="Experience">
      <div className="achievement">
        <div className="circle">8+</div>
        <span>Months</span>
        <span>Experience</span>
      </div>
      <div className="achievement">
        <div className="circle">1+</div>
        <span>Projects</span>
        <span>Completed</span>
      </div>
      <div className="achievement">
        <div className="circle">1</div>
        <span>Company</span>
        <span>Work</span>
      </div>
    </div>
  );
};

export default Experience;
